export const aminoacidsShort = {
  F: "Phe",
  L: "Leu",
  S: "Ser",
  Y: "Tyr",
  C: "Cys",
  W: "Trp",
  P: "Pro",
  H: "His",
  Q: "Gln",
  R: "Arg",
  I: "Ile",
  M: "Met",
  T: "Thr",
  N: "Asn",
  K: "Lys",
  V: "Val",
  A: "Ala",
  D: "Asp",
  E: "Glu",
  G: "Gly",
  // Additional codes for amino acids coded by unusual translations
  U: "Sec",
  O: "Pyl",
  "*": "Ter",
};

export const aminoacidsLong = {
  F: "Phenylalanine",
  L: "Leucine",
  S: "Serine",
  Y: "Tyrosine",
  C: "Cysteine",
  W: "Tryptophan",
  P: "Proline",
  H: "Histidine",
  Q: "Glutamine",
  R: "Arginine",
  I: "Isoleucine",
  M: "Methionine",
  T: "Threonine",
  N: "Asparagine",
  K: "Lysine",
  V: "Valine",
  A: "Alanine",
  D: "Aspartic Acid",
  E: "Glutamic Acid",
  G: "Glycine",
  U: "Selenocysteine",
  "*": "STOP",
};
